import { createBrowserRouter, redirect } from 'react-router';
import { RootLayout } from './layouts/root';
import { DashboardPage } from './pages/dashboard';
import { LoginPage } from './features/auth/pages/LoginPage';
import { OtpChallengePage } from './features/auth/pages/OtpChallengePage';
import { ProductListPage } from './features/catalog/pages/ProductListPage';
import { ProductCreatePage } from './features/catalog/pages/ProductCreatePage';
import { ProductEditPage } from './features/catalog/pages/ProductEditPage';
import { QuantityDiscountPage } from './features/catalog/quantityDiscount/pages/QuantityDiscountPage';
import { CategoryListPage } from './features/catalog/categories/pages/CategoryListPage';
import { NoticeSpecTemplateListPage } from './features/catalog/noticeSpecTemplates/pages/NoticeSpecTemplateListPage';
import { CollectionTemplateListPage } from './features/catalog/collectionTemplates/CollectionTemplateListPage';
import { ConsentTemplatesPage } from './features/catalog/commonConsents/pages/ConsentTemplatesPage';
import { WebFtpPage } from './features/webFtp/pages/WebFtpPage';
import { OrderListPage } from './features/orders/pages/OrderListPage';
import { OrderDetailPage } from './features/orders/pages/OrderDetailPage';
import { InvoiceBulkPage } from './features/orders/invoiceBulk/pages/InvoiceBulkPage';
import { ORDER_ROUTE_ROLES } from './features/orders/lib/orderActionRbac';
import { OrderExportJobsPage } from './features/orders/exportJobs/OrderExportJobsPage';
import { OrderExportTemplatesPage } from './features/orders/exportTemplates/OrderExportTemplatesPage';
import { ORDER_EXPORT_JOB_ROLES } from './features/orders/exportJobs/lib';
import { ProductExportJobsPage } from './features/catalog/exportJobs/ProductExportJobsPage';
import { PRODUCT_EXPORT_JOB_ROLES } from './features/catalog/exportJobs/productExportJobs';
import { PaymentListPage } from './features/payments/pages/PaymentListPage';
import { PaymentDetailPage } from './features/payments/pages/PaymentDetailPage';
import { RefundListPage } from './features/claims/pages/RefundListPage';
import { PAYMENT_ROUTE_ROLES } from './features/payments/lib/paymentActionRbac';
import { ClaimListPage } from './features/claims/pages/ClaimListPage';
import { ClaimDetailPage } from './features/claims/pages/ClaimDetailPage';
import { CLAIM_ROUTE_ROLES } from './features/claims/lib/claimActionRbac';
import { VendorApplicationListPage } from './features/vendor/pages/VendorApplicationListPage';
import { VendorApplicationDetailPage } from './features/vendor/pages/VendorApplicationDetailPage';
import { VENDOR_ROUTE_ROLES } from './features/vendor/lib/vendorActionRbac';
import { FUNDING_ROUTE_ROLES } from './features/funding/lib/fundingActionRbac';
import { ArtistListPage } from './features/artist/pages/ArtistListPage';
import { ArtistCreatePage } from './features/artist/pages/ArtistCreatePage';
import { ArtistDetailPage } from './features/artist/pages/ArtistDetailPage';
import { ARTIST_ROUTE_ROLES } from './features/artist/lib/artistActionRbac';
import { FundingCampaignsPage } from './features/funding/pages/FundingCampaignsPage';
import { FundingDashboardPage } from './features/funding/pages/FundingDashboardPage';
import { FundingCampaignCreatePage } from './features/funding/pages/FundingCampaignCreatePage';
import { FundingCampaignDetailPage } from './features/funding/pages/FundingCampaignDetailPage';
import { SettlementListPage } from './features/settlement/pages/SettlementListPage';
import { SalesAggregationPage } from './features/settlement/pages/SalesAggregationPage';
import { StatsPage } from './features/stats/pages/StatsPage';
import { SettlementDetailPage } from './features/settlement/pages/SettlementDetailPage';
import { ReleaseSchedulesPage } from './features/settlement/pages/ReleaseSchedulesPage';
import { SETTLEMENT_ROUTE_ROLES } from './features/settlement/lib/settlementActionRbac';
import { NotificationMessagePage } from './features/notifications/pages/NotificationMessagePage';
import { NotificationTemplateFormPage } from './features/notifications/pages/NotificationTemplateFormPage';
import {
  NOTIFICATION_PAGE_READ_ROLES,
  NOTIFICATION_TEMPLATE_READ_ROLES,
  NOTIFICATION_TEMPLATE_WRITE_ROLES,
} from './features/notifications/lib/notificationActionRbac';
import { HomeBannerListPage } from './features/cms/pages/HomeBannerListPage';
import { HomeBannerEditPage } from './features/cms/pages/HomeBannerEditPage';
import { MainPageManagePage } from './features/cms/mainPage/pages/MainPageManagePage';
import { OfflineStoreListPage } from './features/cms/pages/OfflineStoreListPage';
import { OfflineStoreEditPage } from './features/cms/pages/OfflineStoreEditPage';
import { PopupListPage } from './features/cms/pages/PopupListPage';
import { PopupEditPage } from './features/cms/pages/PopupEditPage';
import { PopupReservationsPage } from './features/cms/pages/PopupReservationsPage';
// ★홈 팝업(모달)은 위 오프라인 팝업스토어(/cms/popups)와 다른 도메인이다 — 경로·컴포넌트 모두 별개.
import { HomePopupListPage } from './features/cms/homePopups/pages/HomePopupListPage';
import { HomePopupFormPage } from './features/cms/homePopups/pages/HomePopupFormPage';
import { EventListPage } from './features/cms/pages/EventListPage';
import { EventEditPage } from './features/cms/pages/EventEditPage';
import { EventApplicationsPage } from './features/cms/pages/EventApplicationsPage';
import { EventWinnerBoardPage } from './features/cms/pages/EventWinnerBoardPage';
import { NoticeListPage } from './features/cms/notices/pages/NoticeListPage';
import { NoticeFormPage } from './features/cms/notices/pages/NoticeFormPage';
import { EverTvListPage } from './features/cms/everTv/pages/EverTvListPage';
import { EverTvFormPage } from './features/cms/everTv/pages/EverTvFormPage';
import { ExternalServicesPage } from './features/cms/everTv/pages/ExternalServicesPage';
import { CMS_ROUTE_ROLES } from './features/cms/lib/cmsActionRbac';
import { NOTICE_ROUTE_ROLES } from './features/cms/notices/lib/noticeActionRbac';
import { HOME_POPUP_ROUTE_ROLES } from './features/cms/homePopups/lib/homePopupActionRbac';
import { EVER_TV_ROUTE_ROLES } from './features/cms/everTv/lib/everTvActionRbac';
import { CouponListPage } from './features/coupon/pages/CouponListPage';
import { PolicyListPage } from './features/policies/pages/PolicyListPage';
import { PolicyFormPage } from './features/policies/pages/PolicyFormPage';
import { POLICY_ROUTE_ROLES } from './features/policies/lib/policyActionRbac';
import { EarnPolicyListPage } from './features/mileage/pages/EarnPolicyListPage';
import { EarnPolicyFormPage } from './features/mileage/pages/EarnPolicyFormPage';
import { MileageAdminPage } from './features/mileage/pages/MileageAdminPage';
import { DepositAdminPage } from './features/mileage/pages/DepositAdminPage';
import { MILEAGE_READ_ROLES } from './features/mileage/lib/mileageActionRbac';
import { FaqCategoryListPage } from './features/faq/pages/FaqCategoryListPage';
import { FaqListPage } from './features/faq/pages/FaqListPage';
import { FaqFormPage } from './features/faq/pages/FaqFormPage';
import { FAQ_ROUTE_ROLES } from './features/faq/lib/faqActionRbac';
import { InventoryListPage } from './features/inventory/pages/InventoryListPage';
import { UserGradeListPage } from './features/users/grades/pages/UserGradeListPage';
import { UserListPage } from './features/users/pages/UserListPage';
import { UserDetailPage } from './features/users/pages/UserDetailPage';
import { BusinessMemberListPage } from './features/users/business/pages/BusinessMemberListPage';
import { SearchPopularPage } from './features/search/pages/SearchPopularPage';
import { POPULAR_SEARCH_MENU_ENABLED } from './features/search/visibility';
import { AdminAccountListPage } from './features/admin/pages/AdminAccountListPage';
import { AdminAccountFormPage } from './features/admin/pages/AdminAccountFormPage';
import { RoleListPage } from './features/admin/pages/RoleListPage';
import { MyAccountPage } from './features/admin/pages/MyAccountPage';
import { ADMIN_READ_ROLES, ADMIN_WRITE_ROLES } from './features/admin/lib/adminActionRbac';
import { ExchangeRatesPage } from './features/exchangeRates/pages/ExchangeRatesPage';
import { EXCHANGE_RATE_READ_ROLES } from './features/exchangeRates/lib/exchangeRateActionRbac';
import { ShippingManagementPage } from './features/shipping/pages/ShippingManagementPage';
import { CourierManagementPage } from './features/shipping/couriers/pages/CourierManagementPage';
import { COURIER_READ_ROLES } from './features/shipping/couriers/hooks/useShippingCouriers';
import { SHIPPING_MANAGEMENT_READ_ROLES } from './features/shipping/lib/shippingManagementRbac';
import { ManualOrderPage } from './features/manualOrder/pages/ManualOrderPage';
import { MANUAL_ORDER_WRITE_ROLES } from './features/manualOrder/lib/manualOrderRbac';
import { TaxInvoicePage } from './features/taxInvoices/pages/TaxInvoicePage';
import { CashReceiptPage } from './features/cashReceipts/pages/CashReceiptPage';
import { TAX_INVOICE_READ_ROLES } from './features/taxInvoices/api/taxInvoiceApi';
import { CASH_RECEIPT_READ_ROLES } from './features/cashReceipts/api/cashReceiptApi';
import { OrderPolicySettingsPage } from './features/orderPolicy/pages/OrderPolicySettingsPage';
import { ORDER_POLICY_ROLES } from './features/orderPolicy/lib/orderPolicyRbac';
import { ShoppingPolicySettingsPage } from './features/shoppingPolicy/pages/ShoppingPolicySettingsPage';
import { SHOPPING_POLICY_ROLES } from './features/shoppingPolicy/lib/shoppingPolicyRbac';
import { OrderFormFieldsPage } from './features/orderFormFields/pages/OrderFormFieldsPage';
import { ORDER_FORM_FIELD_ROLES } from './features/orderFormFields/lib/orderFormFieldRbac';
import { BankAccountsPage } from './features/bankAccounts/pages/BankAccountsPage';
import { BANK_ACCOUNT_ROLES } from './features/bankAccounts/lib/bankAccountRbac';
import { OpenApiPartnersPage } from './features/openApiPartners/pages/OpenApiPartnersPage';
import { OpenApiPartnerDetailPage } from './features/openApiPartners/pages/OpenApiPartnerDetailPage';
import { OPEN_API_PARTNER_READ_ROLES } from './features/openApiPartners/lib/openApiPartnerRbac';
import { authGuard, rbacLoader } from './lib/rbacGuard';

/**
 * Routes follow architect H3: loaders are AUTH-GUARD-ONLY. No data fetching
 * in loaders — TanStack Query owns all data. Loaders return `redirect(...)`
 * or `null`.
 *
 * authGuard / rbacLoader 는 cold-start silent re-auth 를 포함한다(rbacGuard.ts):
 * 메모리 토큰이 없으면 부팅 1회 refresh 쿠키 복구를 await 한 뒤에만 /login 으로 보낸다.
 */
const productGuard = rbacLoader(['MD_MANAGER', 'OPS_ADMIN', 'SUPER_ADMIN']);
// QA-507 동의 문구 관리 — catalog consent-templates GET 권한(AUDITOR 는 조회만).
const consentTemplateGuard = rbacLoader(['MD_MANAGER', 'OPS_ADMIN', 'SUPER_ADMIN', 'AUDITOR']);
const orderGuard = rbacLoader(ORDER_ROUTE_ROLES);
const orderExportJobGuard = rbacLoader(ORDER_EXPORT_JOB_ROLES);
const productExportJobGuard = rbacLoader(PRODUCT_EXPORT_JOB_ROLES);
const paymentGuard = rbacLoader(PAYMENT_ROUTE_ROLES);
const claimGuard = rbacLoader(CLAIM_ROUTE_ROLES);

const vendorGuard = rbacLoader(VENDOR_ROUTE_ROLES);
const artistGuard = rbacLoader(ARTIST_ROUTE_ROLES);
// 펀딩 캠페인 오픈(r3): 대시보드 리다이렉트 해제 → 실제 RBAC 가드 복원.
const fundingGuard = rbacLoader(FUNDING_ROUTE_ROLES);
const settlementGuard = rbacLoader(SETTLEMENT_ROUTE_ROLES);
const notificationPageGuard = rbacLoader(NOTIFICATION_PAGE_READ_ROLES);
const notificationTemplateReadGuard = rbacLoader(NOTIFICATION_TEMPLATE_READ_ROLES);
const notificationTemplateWriteGuard = rbacLoader(NOTIFICATION_TEMPLATE_WRITE_ROLES);
const cmsGuard = rbacLoader(CMS_ROUTE_ROLES);
const noticeGuard = rbacLoader(NOTICE_ROUTE_ROLES);
// BE 가 SUPER_ADMIN/OPS_ADMIN 만 허용하므로 cmsGuard(MD_MANAGER 포함)를 재사용하지 않는다.
const homePopupGuard = rbacLoader(HOME_POPUP_ROUTE_ROLES);
const everTvGuard = rbacLoader(EVER_TV_ROUTE_ROLES);
const couponGuard = rbacLoader(['MD_MANAGER', 'OPS_ADMIN', 'SUPER_ADMIN']);
const policyGuard = rbacLoader(POLICY_ROUTE_ROLES);
const mileageGuard = rbacLoader(MILEAGE_READ_ROLES);
const faqGuard = rbacLoader(FAQ_ROUTE_ROLES);
const inventoryGuard = rbacLoader(['MD_MANAGER', 'OPS_ADMIN', 'SUPER_ADMIN', 'FULFILLMENT_AGENT']);
const userGradeGuard = rbacLoader(['MD_MANAGER', 'OPS_ADMIN', 'SUPER_ADMIN']);
const userManagementGuard = rbacLoader(['SUPER_ADMIN', 'OPS_ADMIN', 'AUDITOR']);
const searchGuard = rbacLoader(['MD_MANAGER', 'OPS_ADMIN', 'SUPER_ADMIN', 'AUDITOR']);
const adminReadGuard = rbacLoader(ADMIN_READ_ROLES);
const adminWriteGuard = rbacLoader(ADMIN_WRITE_ROLES);
const exchangeRateGuard = rbacLoader(EXCHANGE_RATE_READ_ROLES);
const shippingManagementGuard = rbacLoader(SHIPPING_MANAGEMENT_READ_ROLES);
// QA-510 배송 업체 관리 — 조회는 주문·출고 담당까지(변경은 화면에서 SUPER·OPS).
const courierGuard = rbacLoader(COURIER_READ_ROLES);
const manualOrderGuard = rbacLoader(MANUAL_ORDER_WRITE_ROLES);
const taxInvoiceGuard = rbacLoader(TAX_INVOICE_READ_ROLES);
const cashReceiptGuard = rbacLoader(CASH_RECEIPT_READ_ROLES);
const orderPolicyGuard = rbacLoader(ORDER_POLICY_ROLES);
const shoppingPolicyGuard = rbacLoader(SHOPPING_POLICY_ROLES);
const orderFormFieldGuard = rbacLoader(ORDER_FORM_FIELD_ROLES);
const bankAccountGuard = rbacLoader(BANK_ACCOUNT_ROLES);
const openApiPartnerGuard = rbacLoader(OPEN_API_PARTNER_READ_ROLES);

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  { path: '/login/otp', element: <OtpChallengePage /> },
  {
    path: '/',
    element: <RootLayout />,
    loader: authGuard,
    children: [
      { index: true, loader: () => redirect('/dashboard') },
      { path: 'dashboard', element: <DashboardPage /> },
      { path: 'products', element: <ProductListPage />, loader: productGuard },
      { path: 'products/new', element: <ProductCreatePage />, loader: productGuard },
      { path: 'products/categories', element: <CategoryListPage />, loader: productGuard },
      { path: 'products/exports', element: <ProductExportJobsPage />, loader: productExportJobGuard },
      { path: 'products/notice-spec-templates', element: <NoticeSpecTemplateListPage />, loader: productGuard },
      { path: 'products/collection-templates', element: <CollectionTemplateListPage />, loader: productGuard },
      { path: 'products/consent-templates', element: <ConsentTemplatesPage />, loader: consentTemplateGuard },
      // QA-227 — Web FTP(고도몰 /share/popup_webftp.php 대체). 권한 = BE AdminWebFtpController(SUPER_ADMIN·OPS_ADMIN·MD_MANAGER).
      { path: 'products/web-ftp', element: <WebFtpPage />, loader: productGuard },
      // 배송 관리 통합 — 국내 배송비조건 + 해외 배송비 설정을 탭으로 합친 단일 페이지.
      // 기존 경로(/products/overseas-shipping)를 정식 진입점으로 유지하고, 구 배송비조건
      // 경로(/products/shipping-fee)는 통합 페이지 국내 탭으로 redirect 한다. :productId
      // 매처보다 앞에 둬 흡수 방지.
      { path: 'products/overseas-shipping', element: <ShippingManagementPage />, loader: shippingManagementGuard },
      { path: 'settings/couriers', element: <CourierManagementPage />, loader: courierGuard },
      { path: 'products/shipping-fee', loader: () => redirect('/products/overseas-shipping?tab=domestic') },
      // ID49: 전역 수량할인 설정(per-product 아님 — 기본설정>상품정책). :productId 매처보다 앞에 둬 흡수 방지.
      { path: 'products/quantity-discount', element: <QuantityDiscountPage />, loader: productGuard },
      { path: 'products/:productId', element: <ProductEditPage />, loader: productGuard },
      { path: 'vendors', element: <VendorApplicationListPage />, loader: vendorGuard },
      {
        path: 'vendors/:applicationId',
        element: <VendorApplicationDetailPage />,
        loader: vendorGuard,
      },
      { path: 'artists', element: <ArtistListPage />, loader: artistGuard },
      { path: 'artists/new', element: <ArtistCreatePage />, loader: artistGuard },
      {
        path: 'artists/:artistId',
        element: <ArtistDetailPage />,
        loader: artistGuard,
      },
      {
        path: 'funding-dashboard',
        element: <FundingDashboardPage />,
        loader: fundingGuard,
      },
      {
        path: 'funding-campaigns',
        element: <FundingCampaignsPage />,
        loader: fundingGuard,
      },
      {
        path: 'funding-campaigns/new',
        element: <FundingCampaignCreatePage />,
        loader: fundingGuard,
      },
      {
        // QA-404 — 임시저장(작성중) 캠페인은 등록 폼으로 이어서 쓴다.
        path: 'funding-campaigns/:campaignId/edit',
        element: <FundingCampaignCreatePage />,
        loader: fundingGuard,
      },
      {
        path: 'funding-campaigns/:campaignId',
        element: <FundingCampaignDetailPage />,
        loader: fundingGuard,
      },
      {
        path: 'settlements',
        element: <SettlementListPage />,
        loader: settlementGuard,
      },
      // QA-488 통계(임시 페이지 iframe).
      { path: 'stats', element: <StatsPage />, loader: rbacLoader(['SUPER_ADMIN', 'OPS_ADMIN', 'AUDITOR', 'MD_MANAGER']) },
      {
        path: 'settlements/sales-aggregation',
        element: <SalesAggregationPage />,
        loader: settlementGuard,
      },
      {
        path: 'settlements/:runId',
        element: <SettlementDetailPage />,
        loader: settlementGuard,
      },
      {
        path: 'release-schedules',
        element: <ReleaseSchedulesPage />,
        loader: settlementGuard,
      },
      { path: 'orders', element: <OrderListPage />, loader: orderGuard },
      { path: 'orders/invoice-bulk', element: <InvoiceBulkPage />, loader: orderGuard },
      { path: 'orders/exports', element: <OrderExportJobsPage />, loader: orderExportJobGuard },
      // QA-433 — 주문 엑셀 다운로드 양식(엑셀 다운로드와 같은 권한).
      { path: 'orders/export-templates', element: <OrderExportTemplatesPage />, loader: orderExportJobGuard },
      // ID55 수기주문 등록 — :orderId 매처보다 앞에 둬 'manual' 흡수 방지.
      { path: 'orders/manual', element: <ManualOrderPage />, loader: manualOrderGuard },
      { path: 'orders/tax-invoices', element: <TaxInvoicePage />, loader: taxInvoiceGuard },
      { path: 'orders/cash-receipts', element: <CashReceiptPage />, loader: cashReceiptGuard },
      { path: 'orders/:orderId', element: <OrderDetailPage />, loader: orderGuard },
      { path: 'payments', element: <PaymentListPage />, loader: paymentGuard },
      { path: 'payments/refunds', element: <RefundListPage />, loader: claimGuard },
      {
        path: 'payments/:paymentId',
        element: <PaymentDetailPage />,
        loader: paymentGuard,
      },
      { path: 'claims', element: <ClaimListPage />, loader: claimGuard },
      { path: 'claims/:claimId', element: <ClaimDetailPage />, loader: claimGuard },
      // 메시지(알림톡) 단일 5탭 페이지. 구 분리 라우트는 새 탭으로 redirect(아래).
      {
        path: 'notifications',
        element: <NotificationMessagePage />,
        loader: notificationPageGuard,
      },
      // 구 경로 흡수 — 각 탭으로 redirect(딥링크/북마크 보존). 탭 키는 스펙 정본.
      { path: 'notifications/triggers', loader: () => redirect('/notifications?tab=auto-notification') },
      { path: 'notifications/send/single', loader: () => redirect('/notifications?tab=promotional') },
      { path: 'notifications/send/bulk', loader: () => redirect('/notifications?tab=promotional') },
      // 템플릿 등록/편집은 별도 라우트 유지(단계형 폼 — 스펙 §1 허용). 목록/상세는 템플릿 탭.
      {
        path: 'notifications/templates',
        loader: () => redirect('/notifications?tab=template'),
      },
      {
        path: 'notifications/templates/new',
        element: <NotificationTemplateFormPage />,
        loader: notificationTemplateWriteGuard,
      },
      {
        path: 'notifications/templates/:templateId',
        element: <NotificationTemplateFormPage />,
        loader: notificationTemplateReadGuard,
      },
      { path: 'cms/main-page', element: <MainPageManagePage />, loader: cmsGuard },
      { path: 'cms/home-banners', element: <HomeBannerListPage />, loader: cmsGuard },
      { path: 'cms/home-banners/new', element: <HomeBannerEditPage />, loader: cmsGuard },
      { path: 'cms/home-banners/:bannerId', element: <HomeBannerEditPage />, loader: cmsGuard },
      { path: 'cms/offline-stores', element: <OfflineStoreListPage />, loader: cmsGuard },
      { path: 'cms/offline-stores/new', element: <OfflineStoreEditPage />, loader: cmsGuard },
      { path: 'cms/offline-stores/:storeId', element: <OfflineStoreEditPage />, loader: cmsGuard },
      { path: 'cms/home-popups', element: <HomePopupListPage />, loader: homePopupGuard },
      { path: 'cms/home-popups/new', element: <HomePopupFormPage />, loader: homePopupGuard },
      { path: 'cms/home-popups/:popupId', element: <HomePopupFormPage />, loader: homePopupGuard },
      { path: 'cms/popups', element: <PopupListPage />, loader: cmsGuard },
      { path: 'cms/popups/new', element: <PopupEditPage />, loader: cmsGuard },
      { path: 'cms/popups/:popupId', element: <PopupEditPage />, loader: cmsGuard },
      { path: 'cms/popups/:popupId/reservations', element: <PopupReservationsPage />, loader: cmsGuard },
      { path: 'cms/events', element: <EventListPage />, loader: cmsGuard },
      { path: 'cms/events/new', element: <EventEditPage />, loader: cmsGuard },
      { path: 'cms/events/:eventId', element: <EventEditPage />, loader: cmsGuard },
      { path: 'cms/events/:eventId/applications', element: <EventApplicationsPage />, loader: cmsGuard },
      { path: 'cms/events/:eventId/winners', element: <EventWinnerBoardPage />, loader: cmsGuard },
      { path: 'cms/event-winners', element: <EventWinnerBoardPage />, loader: cmsGuard },
      { path: 'cms/notices', element: <NoticeListPage />, loader: noticeGuard },
      { path: 'cms/notices/new', element: <NoticeFormPage />, loader: noticeGuard },
      { path: 'cms/notices/:noticeId', element: <NoticeFormPage />, loader: noticeGuard },
      { path: 'cms/ever-tv', element: <EverTvListPage />, loader: everTvGuard },
      { path: 'cms/ever-tv/external-services', element: <ExternalServicesPage />, loader: everTvGuard },
      { path: 'cms/ever-tv/new', element: <EverTvFormPage />, loader: everTvGuard },
      { path: 'cms/ever-tv/:videoId', element: <EverTvFormPage />, loader: everTvGuard },
      { path: 'coupons', element: <CouponListPage />, loader: couponGuard },
      { path: 'policies', element: <PolicyListPage />, loader: policyGuard },
      { path: 'policies/new', element: <PolicyFormPage />, loader: policyGuard },
      { path: 'policies/:policyId', element: <PolicyFormPage />, loader: policyGuard },
      { path: 'mileage/earn-policies', element: <EarnPolicyListPage />, loader: mileageGuard },
      { path: 'mileage/earn-policies/new', element: <EarnPolicyFormPage />, loader: mileageGuard },
      { path: 'mileage/earn-policies/:policyId', element: <EarnPolicyFormPage />, loader: mileageGuard },
      { path: 'mileage', element: <MileageAdminPage />, loader: mileageGuard },
      { path: 'deposits', element: <DepositAdminPage />, loader: mileageGuard },
      { path: 'faq/categories', element: <FaqCategoryListPage />, loader: faqGuard },
      { path: 'faq/items', element: <FaqListPage />, loader: faqGuard },
      { path: 'faq/items/new', element: <FaqFormPage />, loader: faqGuard },
      { path: 'faq/items/:faqId', element: <FaqFormPage />, loader: faqGuard },
      { path: 'inventory', element: <InventoryListPage />, loader: inventoryGuard },
      { path: 'users/members', element: <UserListPage />, loader: userManagementGuard },
      { path: 'users/members/:userId', element: <UserDetailPage />, loader: userManagementGuard },
      // R6 O — 사업자(기업)회원 승인/반려 관리. 보기=SUPER/OPS/AUDITOR, 승인·반려는 BE에서 SUPER/OPS 게이트.
      { path: 'users/business', element: <BusinessMemberListPage />, loader: userManagementGuard },
      { path: 'users/grades', element: <UserGradeListPage />, loader: userGradeGuard },
      // QA-360: 숨김 — 주소로 들어와도 대시보드로 보낸다.
      {
        path: 'search/popular',
        element: <SearchPopularPage />,
        loader: POPULAR_SEARCH_MENU_ENABLED ? searchGuard : () => redirect('/dashboard'),
      },
      { path: 'admin/accounts', element: <AdminAccountListPage />, loader: adminReadGuard },
      { path: 'admin/accounts/new', element: <AdminAccountFormPage />, loader: adminWriteGuard },
      { path: 'admin/accounts/:adminUserId', element: <AdminAccountFormPage />, loader: adminReadGuard },
      { path: 'admin/roles', element: <RoleListPage />, loader: adminReadGuard },
      { path: 'admin/me', element: <MyAccountPage />, loader: authGuard },
      { path: 'settings/exchange-rates', element: <ExchangeRatesPage />, loader: exchangeRateGuard },
      // Wave2 주문 기본설정(ID51_1) — 기본설정 그룹.
      { path: 'settings/order-policy', element: <OrderPolicySettingsPage />, loader: orderPolicyGuard },
      // ID51_3 쇼핑 정책(장바구니/관심상품/간편구매) — 기본설정 그룹.
      { path: 'settings/shopping-policy', element: <ShoppingPolicySettingsPage />, loader: shoppingPolicyGuard },
      // §4 글로벌 주문서 추가정보(통관 필드) — 다국어 몰별 항목관리. 기본설정 그룹.
      { path: 'settings/order-form-fields', element: <OrderFormFieldsPage />, loader: orderFormFieldGuard },
      // M-4 [ID52] 무통장 입금 계좌 마스터 — 계좌/노출상점/통화 관리. 기본설정 그룹.
      { path: 'settings/bank-accounts', element: <BankAccountsPage />, loader: bankAccountGuard },
      { path: 'settings/open-api-partners', element: <OpenApiPartnersPage />, loader: openApiPartnerGuard },
      { path: 'settings/open-api-partners/:partnerId', element: <OpenApiPartnerDetailPage />, loader: openApiPartnerGuard },
    ],
  },
]);
